import { Fragment, useState } from "react";
import classNames from "classnames";
import Balancer from "react-wrap-balancer";
import ContactForm from "./components/contactForm";
import Carousel from "./components/carousel";
import Select from "components/select/select";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import type { SelectValuesType } from "./types";

const innerContainerClasses = classNames(
  "mx-auto w-100 max-w-[1040px] px-5 lg:max-w-[1220px] lg:px-0"
);

const SiftedForStartupsView = ({ data }) => {
  const { track } = useMixpanelTracking();
  const [activeRole, setActiveRole] = useState<SelectValuesType | undefined>(
    undefined
  );

  return (
    <Fragment>
      <main className="w-full overflow-x-hidden bg-[#F4F4F6] pt-[65px] text-black-rock">
        <div
          className={classNames(
            innerContainerClasses,
            "pb-[60px] pt-[30px] md:pt-[60px]"
          )}
        >
          <div className="mt-[10px] flex w-full flex-col items-center">
            <h1 className="text-center font-recklessBold text-[32px] leading-[130%] text-[#EE4036] md:text-[52px]">
              {data.heroTitle}
            </h1>

            <p className="mt-2 text-center font-bold text-[22px] leading-[130%] text-mono-70  md:text-[24px]">
              {data.heroSubtitle}
            </p>

            <p className="mb-[30px] mt-4 text-center text-[18px] leading-[130%] text-mono-70">
              {data.heroText}
            </p>

            <Carousel slides={data.heroSlides} />
            <p className="mt-[30px] max-w-[800px] text-balance text-center text-[14px] text-mono-40">
              {data.heroTerms}
            </p>
          </div>
        </div>
        <div className="w-full bg-white">
          <div
            className={classNames(
              innerContainerClasses,
              "flex flex-col pb-[100px] pt-[60px]"
            )}
          >
            <p className="mx-auto w-full text-center font-recklessBold text-[18px] leading-[130%] text-black-rock md:w-11/12 md:text-[26px] lg:w-4/5">
              <Balancer>{data.selectionHeader}</Balancer>
            </p>
            <div className="mx-auto mb-[30px] mt-5">
              <Select
                value={activeRole}
                setValue={setActiveRole}
                width={320}
                placeholder="Select your job role"
                options={[
                  {
                    value: "Founders and C-Suite",
                    label: "Founders and C-Suite",
                  },
                  { value: "Operators", label: "Operators" },
                ]}
                onValueChange={async (value) => {
                  await track("Role change", {
                    "New value": value,
                  });
                }}
                ariaLabel="Select your job role"
              />
            </div>
            <ContactForm role={activeRole} />
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default SiftedForStartupsView;
